import { createAction, props } from "@ngrx/store";
import { INotifications } from "../../../interfaces/notifications/INotifications";


export const loadMessages = createAction(
    '[Notifications] Load Messages'
);

export const loadMessagesSuccess = createAction(
    '[Notifications] Load Messages Success',
    props< { messages: INotifications[] }>()
)

export const loadMessagesFailure = createAction(
    '[Notifications] Load Messages Failure',
    props< { error: string }>()
)

export const saveMessageNotification = createAction(
    '[Notifications] Save Message Notification',
    props< { message: { title: string; body: Record<string, any>; icon: string} }>()
)

export const saveMessageNotificationSuccess = createAction(
    '[Notifications] Save Message Notification Success'
)

export const saveMessageNotificationFailure = createAction(
    '[Notifications] Save Message Notification Failure',
    props< { error: string }>()
)

export const visualizeMessageNotification = createAction(
    '[Notifications] Visualize Message Notification',
)
export const visualizeMessageNotificationSuccess = createAction(
    '[Notifications] Visualize Message Notification Success'
)
export const visualizeMessageNotificationFailure = createAction(
    '[Notifications] Visualize Message Notification Failure',
    props< { error: string }>()
)